import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { MaskLines, Reveal, EASE } from "./Reveal";
import { FAQS } from "../data/content";

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="px-6 sm:px-10 lg:px-16 py-16 sm:py-32 max-w-[1200px] mx-auto">
      <MaskLines
        as="h2"
        lines={[<>Frequently asked <span className="font-serif italic font-normal">questions.</span></>]}
        className="font-display font-medium tracking-[-0.03em] leading-[1.05] text-3xl sm:text-5xl text-charcoal mb-12 sm:mb-16"
      />
      <div className="border-b border-charcoal/10">
        {FAQS.map((f, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <div className="border-t border-charcoal/10">
              <button
                data-testid={`faq-question-${i + 1}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-6 sm:py-8 text-left group"
              >
                <span className={`font-display font-semibold tracking-tight text-lg sm:text-2xl transition-colors duration-300 ${open === i ? "text-ember" : "text-charcoal group-hover:text-ember"}`}>
                  {f.q}
                </span>
                <span className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-500 ${open === i ? "bg-flame border-flame text-white rotate-45" : "border-charcoal/20 text-charcoal"}`}>
                  <Plus className="w-4 h-4" />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p data-testid={`faq-answer-${i + 1}`} className="pb-8 pr-10 sm:pr-24 text-sm sm:text-base text-charcoal/60 leading-relaxed max-w-3xl">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
